import {useNuxtApp} from "nuxt/app"
import {defineStore} from 'pinia'
import {ref} from 'vue'
import {useNotification} from "@/composables/useNotification"

export const useContentStore = defineStore('content', () => {
    const contentData = ref(null)
    const contentLoading = ref(false)

    function storeContentData(response) {
        contentData.value = {...response.data?.value?.organisationsEntries?.[0]}
    }

    async function fetchContentData(id) {
        if (id) {
            contentLoading.value = true
            await useAsyncGql('organisation', {organisationId: id})
                .then(storeContentData)
                .catch(handleRequestError)
                .finally(() => {
                    contentLoading.value = false
                })
        }
    }

    function handleRequestError(error) {
        const notification = useNotification()
        const app = useNuxtApp()
        if (error && error.response && error.response.status === 422) {
            notification.error(app.$i18n.t('invalidRequestData') + '\n' + error.response._data.message)
        } else {
            if (error && error.response?._data.message) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
            } else if ( error && error.response?._data) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
            } else {
                notification.error(app.$i18n.t('generalRequestError'))
            }
        }
    }

    return {
        contentData,
        contentLoading,
        fetchContentData
    }
})
